import DataTableBodyRows from './DataTableBodyRows';
export default DataTableBodyRows;
